import { ROW_ACTIONS_FIELD } from '../constants/actions'
import { ITableProps } from '../types'

export const prepareColumns = <T>(
  columns: ITableProps<T>['columns'],
  rowActions: ITableProps<T>['rowActions'],
  rowActionsVisible: ITableProps['rowActionsVisible']
) => {
  const columnsData = [...columns]

  const actionWidth = 34
  if (rowActions?.length && rowActionsVisible === 'visible') {
    const hasColumn = columns.find((col, index) => {
      const isLastElement = index === columns.length - 1
      return col.field === ROW_ACTIONS_FIELD && isLastElement
    })
    if (!hasColumn) {
      columnsData.push({
        title: '',
        field: ROW_ACTIONS_FIELD,
        width: `${rowActions.length * actionWidth}px`,
        disableSort: true,
        withoutOperator: true,
        hideSettings: true,
        priority: 999999,
      })
    }
  }
  return columnsData
}
